import { AppState } from 'Store'

const getActs = (state: AppState) => state.act.data
const getActsRequestParams = (state: AppState) => state.act.requestParams

const getActStatusesRequestParams = (state: AppState) => state.actStatuses.requestParams

const getActsCancelKinds = (state: AppState) => state.act.cancel_kinds.data

const getUserCertificates = (state: AppState) => state.act.certificates
const getOpenedAct = (state: AppState) => state.act.openedAct

const getSignableActsCount = (state: AppState) => state.act.signableActsCount

const getActsGridView = (state: AppState) => state.act.gridView
const getCurrentActsFilter = (state: AppState) => state.act.currentFilter

const getProtocolGenerationValidation = (state: AppState) =>
	state.act.counterProtocolGenerationValidation

const getItem = (state: AppState) => state.act.item

const getChosenActs = (state: AppState) => state.act.chosenActs

const getTimer = (state: AppState) => state.act.timer

export const ActsSelector = {
	getActs,
	getActsRequestParams,
	getActStatusesRequestParams,
	getActsCancelKinds,
	getUserCertificates,
	getOpenedAct,
	getSignableActsCount,
	getActsGridView,
	getCurrentActsFilter,
	getProtocolGenerationValidation,
	getItem,
	getChosenActs,
	getTimer,
}
